const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

const normalizeCandidate = (value) => String(value || "").trim();

const isObjectIdLike = (value) => OBJECT_ID_PATTERN.test(normalizeCandidate(value));

export const getDirectShopSlug = (source) => {
  if (!source) return null;

  if (typeof source === "string") {
    const candidate = normalizeCandidate(source);
    if (!candidate || isObjectIdLike(candidate)) return null;
    return candidate;
  }

  const candidates = [
    source.storefrontHandle,
    source.businessId?.storefrontHandle,
    source.professionalId?.storefrontHandle,
    source.slug,
    source.shopSlug,
    source.locationSlug,
    source.shopId?.slug,
    source.activeLocation?.slug,
    source.shopIds?.[0]?.slug,
  ];

  const resolved = candidates
    .map(normalizeCandidate)
    .find((candidate) => candidate && !isObjectIdLike(candidate));

  return resolved || null;
};

export const getDirectShopCataloguePath = (source) => {
  if (!source) return null;

  const storefrontHandle = normalizeCandidate(
    source.storefrontHandle ||
      source.businessId?.storefrontHandle ||
      source.professionalId?.storefrontHandle,
  );

  if (storefrontHandle && !isObjectIdLike(storefrontHandle)) {
    return `/shop/${encodeURIComponent(storefrontHandle)}/products`;
  }

  const slug = getDirectShopSlug(source);
  return slug ? `/shop/${encodeURIComponent(slug)}/products` : null;
};
